<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore, useMapGetter } from 'dashboard/composables/store';

import Button from 'dashboard/components-next/button/Button.vue';
import FunnelBoard from 'dashboard/components-next/funnels/FunnelBoard.vue';

const store = useStore();
const { t } = useI18n();

const funnels = useMapGetter('funnels/getFunnels');
const uiFlags = useMapGetter('funnels/getUIFlags');

const selectedFunnelId = ref(null);

const selectedFunnel = computed(() =>
  funnels.value.find(funnel => funnel.id === selectedFunnelId.value)
);

onMounted(() => {
  store.dispatch('funnels/fetchFunnels');
});

watch(
  funnels,
  newFunnels => {
    if (newFunnels.length && !selectedFunnelId.value) {
      selectedFunnelId.value = newFunnels[0].id;
    }
  },
  { immediate: true }
);
</script>

<template>
  <div class="flex flex-col w-full h-full overflow-hidden bg-n-background">
    <header class="flex flex-wrap items-center gap-3 px-6 py-4 shrink-0">
      <h1 class="text-xl font-medium text-n-slate-12">
        {{ t('FUNNELS.HEADER') }}
      </h1>
      <div v-if="funnels.length > 1" class="flex flex-wrap gap-2">
        <Button
          v-for="funnel in funnels"
          :key="funnel.id"
          :label="funnel.name"
          size="sm"
          :variant="funnel.id === selectedFunnelId ? 'solid' : 'faded'"
          @click="selectedFunnelId = funnel.id"
        />
      </div>
    </header>

    <section class="flex-1 min-h-0 px-6 pb-6 overflow-hidden">
      <div
        v-if="uiFlags.isFetchingFunnels"
        class="flex items-center justify-center h-full text-sm text-n-slate-11"
      >
        {{ t('FUNNELS.LOADING') }}
      </div>
      <div
        v-else-if="!funnels.length"
        class="flex items-center justify-center h-full text-sm text-n-slate-11"
      >
        {{ t('FUNNELS.EMPTY_STATE') }}
      </div>
      <FunnelBoard v-else-if="selectedFunnel" :funnel="selectedFunnel" />
    </section>
  </div>
</template>
